import { Popover } from "@cloudscape-design/components";
import { mdiTowTruck } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { ItemFlight } from "../../resources/types";
import BadgeCustom from "./BadgeCustom";

type BadgeAltitudesProps = {
  flight: ItemFlight;
  size?: "small" | "medium" | "large";
  type?: "min" | "normal",
  width?: number;
};

const BadgeAltitudes: React.FC<BadgeAltitudesProps> = ({ flight, type = "min" }) => {
  if (!flight || !flight.altitude) return null;

  return (
    <>
      <BadgeCustom color={flight.altitude === 0 ? "light" : "grey"} size={"small"}>
        {/* If type is "min", wrap the abbreviation (userType.ut) in a Popover 
                    that shows the full name (userType.displayName) on hover.
                */}
        {type === "min" ? (
          <Popover header="Remolque" content={`${flight.altitude} metros`}
            dismissButton={false} triggerType="custom">
            {flight.altitude === 0 ? "SR" : <><Icon path={mdiTowTruck} size={0.75} />{flight.altitude.toString().substring(0, 2)}</>}
          </Popover>
        ) : (
          /* Otherwise, show the full display name */
          <>Remolque {flight.altitude} metros</>
        )}
      </BadgeCustom>
    </>
  );
};

export default BadgeAltitudes;
